<template>
  <div class="col-12 py-4">
    <button
      v-if="
        checked_in == false &&
          $store.state.app.match &&
          $store.state.app.match.related_campaign != null
      "
      @click="checkIn"
      class="confirm-button mt-2"
    >
      {{
        $store.state.user != null &&
        $store.state.app.match &&
        $store.state.app.match.related_campaign != null
          ? checkInType == "checkin"
            ? "Check-in"
            : "Desteğini Göster"
          : "Check-in için giriş yap"
      }}
    </button>
    <button v-if="checked_in == true" class="confirm-button mt-2">
      {{
        checkedInType == "checkin"
          ? "Check-in Yaptınız"
          : "Desteğinizi Gösterdiniz"
      }}
    </button>

    <transition-group
      name="list-complete"
      tag="div"
      style="overflow: hidden;width: 100%; display: flex; align-items: center; justify-content: flex-end; margin-top: 10px;"
    >
      <div
        @click="addNew"
        class="list-complete-item"
        style="width: 40px; height: 40px; border-radius: 20px; margin-right: 5px;"
        v-for="(item, index) in checkIns"
        :key="item.id"
      >
        <div
          style="width: 40px; height: 40px; border-radius: 20px; box-shadow: 0px 0px 5px rgba(0,0,0,.3); background-size: cover; "
          :style="'background-image: url(' + item.avatarUrl + ')'"
        >
          <div
            v-if="item.avatarUrl.indexOf('default') != -1"
            style="background-color: rgba(0,0,0,.6); color: white; font-weight: bold; display: flex; align-items: center; justify-content: center; position: absolute; width: 40px; height: 40px; border-radius: 20px;"
          >
            {{ item.first_name.charAt(0) }}.{{ item.last_name.charAt(0) }}
          </div>
        </div>
      </div>
    </transition-group>

    <div
      v-if="totalCheckin != null"
      style="width: 100%; text-align: right; margin-top: 10px;"
    >
      {{ totalCheckin }} kişi bu maçta.
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Pusher from "pusher-js";
import moment from "moment";
export default {
  name: "CheckIn",
  data() {
    return {
      tab: null,
      statisticsType: "home",
      currentDate: new Date().getTime(),
      moment,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 0,
            Q2: 0,
            Q3: 0,
            Q4: 0
          },
          away: {
            final: 0,
            Q1: 0,
            Q2: 0,
            Q3: 0,
            Q4: 0
          }
        }
      },
      activeSlide: 0,
      id: this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message:
          "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0,
      match: {
        id: null,
        location: null,
        tournamentId: "",
        tournamentName: "",
        homeTeam: {
          name: "Anadolu Efes",
          logo_url: ""
        },
        awayTeam: {
          name: "",
          logo_url: ""
        },
        date: "",
        date2: "",
        status: "",
        score1: "",
        score2: "",
        timeMinute: "",
        timeSecond: ""
      },
      checkInType: null,
      checkedInType: null,
      checkIns: [],
      totalCheckin: null
    };
  },
  mounted() {
    let pusher = new Pusher(this.$store.state.pusher_staging, {
      cluster: "eu"
    });
    pusher.subscribe("live-match-checkin-" + this.$store.state.app.match.id);
    pusher.bind("live-match-checkin-event", data => {
      this.checkIns.push(data);
      this.totalCheckin += 1;
    });

    var data = new FormData();
    data.append("match_id", this.$store.state.app.match.id);
    data.append("page", 1);

    axios.post("sosyal/maca-checkin-yapanlar", data).then(res => {
      this.checkIns = res.data.data.reverse();
      this.totalCheckin = res.data.totalCount;
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          var data = new FormData();
          data.append("id", this.$store.state.app.match.related_campaign);
          data.append("email", this.$store.state.user.email);
          data.append("token", this.$store.state.user.token);
          data.append("latitude", pos.coords.latitude);
          data.append("longitude", pos.coords.longitude);

          axios.post("kampanya/lokasyon-kontrolu", data).then(res => {
            this.checkInType = res.data.type;
          });
        },
        error => {
          this.checkInType = "support";
        }
      );
    }
    var data = new FormData();
    if (this.$store.state.app.match) {
      data.append("id", this.$store.state.app.match.related_campaign);
    }

    if (this.$store.state.user != null) {
      data.append("email", this.$store.state.user.email);
      data.append("token", this.$store.state.user.token);

      axios.post("kampanya/checkin-olmus-mu", data).then(res => {
        this.checked_in = res.data.checked_in;
        this.checkedInType = res.data.type;
      });
    }
  },
  methods: {
    checkIn() {
      if (this.$store.state.user == null) {
        this.$router.push({ name: "Login" });
      } else {
        this.$store.state.loading = true;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            pos => {
              var data = new FormData();
              data.append("id", this.$store.state.app.match.related_campaign);
              data.append("email", this.$store.state.user.email);
              data.append("token", this.$store.state.user.token);
              data.append("latitude", pos.coords.latitude);
              data.append("longitude", pos.coords.longitude);

              axios.post("kampanya/katil", data).then(res => {
                this.$store.state.loading = false;
                if (res.data.data.status == true) {
                  this.checked_in = true;

                  this.$router.push({
                    name: "Success",
                    params: { data: res.data.data }
                  });
                } else {
                  this.$notify({
                    title: "Hata",
                    message: res.data.data.error,
                    type: "error"
                  });
                }
              });
            },
            error => {
              this.$store.state.loading = false;
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Konum izni vermediğiniz için check-in yapamazsınız. Lütfen ayarlardan izin erip tekrar deneyin.",
                    type: "error"
                  });
                  break;
                case error.POSITION_UNAVAILABLE:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Konum alınamadı. Telefonunuzun internet ve gps bağlantısının olduğundan emin olun.",
                    type: "error"
                  });
                  break;
                case error.TIMEOUT:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Konumunuzu almamız çok uzun sürdü. Lütfen tekrar deneyin",
                    type: "error"
                  });
                  break;
                case error.UNKNOWN_ERROR:
                  this.$notify({
                    title: "Hata",
                    message:
                      "Bilinmeyen bir hata oluştur. Lütfen tekrar deneyin.",
                    type: "error"
                  });
                  break;
              }
            }
          );
        }
      }
    },
    addNew() {
      this.checkIns.push({
        first_name: "A",
        last_name: "B",
        avatarUrl: "default",
        id: new Date().getTime()
      });
    }
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckIn.vue